import { render, staticRenderFns } from "./SignUpFranchisorStepTwo.vue?vue&type=template&id=31ca02a8&scoped=true&"
import script from "./SignUpFranchisorStepTwo.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchisorStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchisorStepTwo.vue?vue&type=style&index=0&id=31ca02a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca02a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
